import { render, staticRenderFns } from "./StoneImage.vue?vue&type=template&id=54619b26&scoped=true&"
import script from "./StoneImage.vue?vue&type=script&lang=js&"
export * from "./StoneImage.vue?vue&type=script&lang=js&"
import style0 from "./StoneImage.vue?vue&type=style&index=0&id=54619b26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54619b26",
  null
  
)

export default component.exports